<div class="form-group" [class.has-error]="showError">

  <ng-template #htmlContent>
    <div class="tooltip-content-selectable" [innerHTML]="to.tooltip.content"></div>
  </ng-template>

  <label *ngIf="onlyTooltipWrapper && to.label && to.hideLabel !== true" [attr.for]="id">
    {{ to.label }}
    <span *ngIf="to.required && to.hideRequiredMarker !== true">*</span>
  </label>
  <span *ngIf="showTooltip() && !isToolTipAlignmentAdjustRequired()">
    <span
      *ngIf="to.tooltip"
      class="input-tooltip"
      [ngbTooltip]="htmlContent"
      triggers="manual"
      #tooltip="ngbTooltip"
      (mouseenter)="tooltip.open()"
      (mouseleave)="closeTooltipWithDelay(tooltip, 2000)">
      ?
    </span>
  </span>
  <span *ngIf="showTooltip() && isToolTipAlignmentAdjustRequired()">
    <span
      *ngIf="to.tooltip"
      class="input-tooltip-align"
      [ngbTooltip]="htmlContent"
      triggers="manual"
      #tooltipAlign="ngbTooltip"
      (mouseenter)="tooltipAlign.open()"
      (mouseleave)="closeTooltipWithDelay(tooltipAlign, 2000)">
      ?
    </span>
  </span>
  <ng-template #fieldComponent></ng-template>
  <div *ngIf="onlyTooltipWrapper && showError" class="invalid-feedback" [style.display]="'block'">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="onlyTooltipWrapper && to.description" class="form-text text-muted">{{ to.description }}</small>
</div>
